import {AdjacencyMap} from 'util/graph-utils/GraphUtilConstants';

/**
 * Finds all paths connecting two nodes, excluding any cycles.
 *
 * Paths only include intermediate nodes (i.e. the fromNode and toNode are not included).
 *
 * @param fromNodeId The ID of the node to start the search from
 * @param toNodeId: The ID of the node to end the search at
 * @param adjacencyMap The adjacency map representing the graph
 * @returns A list of paths between the two nodes, excluding the nodes themselves
 */
export function getAllPathsBetweenNodes(
  fromNodeId: string,
  toNodeId: string,
  adjacencyMap: AdjacencyMap
): Array<Array<string>> {
  const paths: Array<Array<string>> = [];
  const stack: Array<{nodeId: string; nodeIdsInPath: Array<string>; visitedNodeIds: Set<string>}> = [
    {nodeId: fromNodeId, nodeIdsInPath: [], visitedNodeIds: new Set([fromNodeId])},
  ];

  while (stack.length > 0) {
    const {nodeId, nodeIdsInPath, visitedNodeIds} = stack.pop()!;
    if (nodeId === toNodeId) {
      paths.push(nodeIdsInPath);
      continue;
    }
    const nextNodes = adjacencyMap[nodeId];
    for (const nextNode of nextNodes) {
      // Prevent cycles from being included in paths
      if (visitedNodeIds.has(nextNode)) {
        continue;
      }
      // we exclude the first node from the path
      const newNodeIdsInPath = nodeId === fromNodeId ? nodeIdsInPath : [...nodeIdsInPath, nodeId];
      stack.push({
        nodeId: nextNode,
        nodeIdsInPath: newNodeIdsInPath,
        visitedNodeIds: new Set([...visitedNodeIds, nextNode]),
      });
    }
  }

  return paths;
}
